<template>
  <div class="min-h-screen bg-gray-50 px-4 pt-6 pb-28" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header Card -->
      <div class="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-6 text-white">
        <div class="space-y-2">
          <div class="flex items-center gap-3">
            <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div class="w-full">
              <h2 class="text-lg font-bold">اطلاعات مشتری</h2>
              <p class="text-xs text-blue-50">{{ branch_name }}</p>
            </div>
          </div>
          <div v-if="level==1" class="flex w-full items-center gap-2 mt-3 pt-3 border-t border-white border-opacity-20">
            <span class="text-sm font-medium">{{$t('techName')}}:</span>
            <span class="text-sm">{{ profile.UserName }}</span>
          </div>
        </div>
      </div>

      <!-- Customer Info Card -->
      <div class="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
        
        <!-- Mobile Input -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('customerMobileNo') }}</label>
          <div class="relative">
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <input
              v-model="mobile"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              :placeholder="$t('customerMobileNo')"
              class="w-full pl-11 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              style="border: 1px solid #d1d5db !important;"
            />
          </div>
        </div>

        <!-- Display Full Name (if registered) -->
        <div v-if="fullName2!='' && level==1" class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div class="flex items-center gap-3">
            <div class="w-12 h-10 rounded-full bg-blue-100 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div class="w-full">
              <p class="font-bold text-gray-900">
                <span class="font-normal text-sm">
                  مشتری یافت شده: 
                </span>
                {{ fullName2 }}</p>
            </div>
          </div>
        </div>

        <!-- Register New Customer Form (level 2) -->
        <div v-if="level==2" class="space-y-4">
          <!-- Full Name -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('fullName') }}</label>
            <div class="relative">
              <div class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <input
                v-model="fullName2"
                type="text"
                :placeholder="$t('fullName')"
                class="w-full pr-11 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                style="border: 1px solid #d1d5db !important;"
              />
            </div>
          </div>

          <!-- National Code -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('nationalCode') }}</label>
            <div class="relative">
              <div class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg class="w-5 h-5 " fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                </svg>
              </div>
              <input
                v-model="nationalCode"
                type="text"
                :placeholder="$t('nationalCode')"
                class="w-full pr-11 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                style="border: 1px solid #d1d5db !important;"
              />
            </div>
          </div>
        </div>

        <!-- Invoice type + company fields (after mobile step) -->
        <div v-if="user_registered || level==2" class="space-y-4 pt-2 border-t border-gray-100">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              نوع فاکتور را بپرسید
              <span class="text-red-500">*</span>
            </label>
            <p class="text-xs text-gray-500 mb-2">مسئولیت انتخاب فاکتور به عهده مشتری می باشد.</p>
            <div class="relative">
              <select
                v-model="invoiceType"
                class="w-full px-4 pr-4 pl-10 py-3 border border-gray-300 rounded-lg text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white"
                style="border: 1px solid #d1d5db !important;"
              >
                <option value="">انتخاب کنید</option>
                <option value="unofficial">غیر رسمی</option>
                <option value="official">رسمی</option>
              </select>
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>

          <div v-if="invoiceType === 'official'" class="space-y-4">
            <div class="relative">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                شناسه ملی شرکت
                <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                  </svg>
                </div>
                <input
                  v-model="companyNationalId"
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  placeholder="شناسه ملی شرکت"
                  class="w-full pr-11 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  style="border: 1px solid #d1d5db !important;"
                  @input="onCompanyNationalIdInput"
                />
              </div>

              <div
                v-if="companySearching"
                class="mt-2 text-xs text-blue-600"
              >
                در حال جستجو...
              </div>

              <div
                v-else-if="companyResults.length"
                class="mt-2 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto"
              >
                <button
                  v-for="(item, index) in companyResults"
                  :key="index"
                  type="button"
                  class="w-full text-right px-3 py-2 hover:bg-blue-50 border-b border-gray-100 last:border-b-0"
                  @click="selectCompany(item)"
                >
                  <div class="text-sm text-gray-900">{{ getCompanyTitle(item) }}</div>
                  <div class="text-xs text-gray-500">{{ getCompanyNationalId(item) }}</div>
                </button>
              </div>

              <div
                v-else-if="companySelected"
                class="mt-2 text-xs text-green-600 bg-green-50 border border-green-200 rounded-lg px-3 py-2"
              >
                شرکت یافت شد و اطلاعات پر شد.
              </div>

              <div
                v-else-if="companySearched && companyNationalId.length >= 9"
                class="mt-2 text-xs text-amber-600 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2"
              >
                شرکت یافت نشد — شرکت جدید است. نام شرکت را وارد کنید.
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                نام شرکت
                <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <input
                  v-model="companyLegalTitle"
                  type="text"
                  placeholder="نام شرکت"
                  :readonly="companySelected"
                  class="w-full pr-11 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  :class="{ 'bg-gray-50': companySelected }"
                  style="border: 1px solid #d1d5db !important;"
                />
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Action Buttons -->
      <div class="space-y-3">
        <!-- Register Button (level 2) -->
        <button 
          v-if="level==2"
          @click="login()"
          class="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          {{$t('register')}}
        </button>

        <!-- Not Registered Link -->
        <div v-if="level==1 && not_register" class="text-center">
          <button 
            @click="level=2"
            class="text-blue-600 hover:text-blue-700 font-medium text-sm transition-colors"
          >
            {{$t('customerNotRegistered')}}
          </button>
        </div>

        <!-- Continue Button (if registered) -->
        <button 
          v-if="user_registered"
          @click="go_to_categories()"
          class="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2"
        >
          {{ $t('insert_info') }}
          <svg class="w-5 h-5 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </button>
      </div>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        mobile: '',
        fullName2: '',
        lastfullName2: '',
        customer_name: '',
        branch_name: localStorage.getItem('branch_name'),
        password: '',
        profile:  JSON.parse(localStorage.getItem('profile')),
        nationalCode: '',
        invoiceType: '',
        companyNationalId: '',
        companyLegalTitle: '',
        companyResults: [],
        companySearching: false,
        companySearched: false,
        companySelected: false,
        companyFillingFromApi: false,
        companySearchTimer: null,
        companySearchSeq: 0,
        valid: true,
        not_register: false,
        user_registered: false,
        level: 1,
        rules: {
          required: value => !!value || this.$t('required'),
          // fullName: value => value.length <= 30 || 'ماکسیمم 30 کاراکتر می باشد.',
          // PersianFullName: value => {
          //   const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاكتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
          //   return pattern.test(value) || 'نام و نام خانوادگی فارسی نیست.'
          // },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('mobileNotCorrect')
          },
        },
      }
    },
    mounted() {
      // Set header title based on service type
      try {
        const requestData = JSON.parse(localStorage.getItem('request_data'))
        if (requestData && requestData.on_site_service !== undefined) {
          // on_site_service: true = ثبت در شعبه, false = ثبت در محل
          this.$route.meta.name = requestData.on_site_service ? 'ثبت در شعبه' : 'ثبت در محل'
          // Trigger a re-render of header
          this.$forceUpdate()
        }
      } catch (e) {
        console.error('Error reading request_data:', e)
      }
    },
watch: {
      mobile: function () {
        this.not_register = false
        this.user_registered = false
        this.fullName2 = ''
        this.lastfullName2 = ''
        this.invoiceType = ''
        this.resetCompanyFields()

        console.log('mobile changed')
        if (this.mobile.length == 11 && this.level == 1) {
          this.login()
        }
      },
      invoiceType: function (newVal) {
        if (newVal !== 'official') {
          this.resetCompanyFields()
        }
      },
      fullName2: function () {
      if (this.level == 2) {
        var pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاكتنكيمکيگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
        // return pattern.test(last_char) || 'نام و نام خانوادگی فارسی نیست.'
        if (this.fullName2 != '') {
          if (!pattern.test(this.fullName2)) {
            this.fullName2 = this.lastfullName2
          } else {
            this.lastfullName2 = this.fullName2
          }
        }
      }
      }
      // }
    },
    beforeDestroy () {
      if (this.companySearchTimer) {
        clearTimeout(this.companySearchTimer)
      }
    },
    methods: {
      resetCompanyFields () {
        this.companyNationalId = ''
        this.companyLegalTitle = ''
        this.companyResults = []
        this.companySearching = false
        this.companySearched = false
        this.companySelected = false
        this.companyFillingFromApi = false
        if (this.companySearchTimer) {
          clearTimeout(this.companySearchTimer)
          this.companySearchTimer = null
        }
      },
      getCompanyTitle (item) {
        if (!item) return ''
        return item.LegalTitle != null ? String(item.LegalTitle) : ''
      },
      getCompanyNationalId (item) {
        if (!item) return ''
        return item.NationalID != null ? String(item.NationalID) : ''
      },
      parseCompaniesResponse (raw) {
        let data = raw
        if (data == null) return []

        if (typeof data === 'string') {
          const trimmed = data.trim()
          if (!trimmed) return []
          try {
            data = JSON.parse(trimmed)
          } catch (e) {
            return []
          }
        }

        if (Array.isArray(data)) return data

        if (typeof data !== 'object') return []

        const candidates = [data.items, data.Items, data.data, data.Data, data.result, data.Result]
        for (let i = 0; i < candidates.length; i++) {
          let value = candidates[i]
          if (value == null) continue
          if (typeof value === 'string') {
            try {
              value = JSON.parse(value)
            } catch (e) {
              continue
            }
          }
          if (Array.isArray(value)) return value
        }

        return []
      },
      onCompanyNationalIdInput () {
        if (this.companyFillingFromApi) return

        this.companySelected = false
        this.companyLegalTitle = ''
        this.companyResults = []
        this.companySearched = false

        if (this.companySearchTimer) {
          clearTimeout(this.companySearchTimer)
        }

        const srch = this.persian_to_english((this.companyNationalId || '').trim())
        if (srch.length < 9) {
          this.companySearching = false
          return
        }

        this.companySearchTimer = setTimeout(() => {
          this.searchCompanies(srch)
        }, 1000)
      },
      searchCompanies (srchTxt) {
        this.companySearchSeq += 1
        const seq = this.companySearchSeq
        this.companySearching = true
        this.companySearched = false
        const send_data = {
          UserId: this.profile.UserId,
          PageNo: 1,
          SrchTxt: srchTxt,
        }
        this.axios.post('/GetCompanies', send_data, { show_pros: false })
          .then(response => {
            if (seq !== this.companySearchSeq) return

            const items = this.parseCompaniesResponse(response.data)
            this.companyResults = items
            this.companySearched = true
            this.companySelected = false
            this.companyLegalTitle = ''
          })
          .catch(() => {
            if (seq !== this.companySearchSeq) return
            this.companyResults = []
            this.companySearched = true
            this.companySelected = false
          })
          .finally(() => {
            if (seq !== this.companySearchSeq) return
            this.companySearching = false
          })
      },
      selectCompany (item) {
        if (!item) return
        this.companyFillingFromApi = true
        // فقط از فیلدهای مشخص API پر کن؛ جابه‌جا نشوند
        this.companyNationalId = this.getCompanyNationalId(item)
        this.companyLegalTitle = this.getCompanyTitle(item)
        this.companySelected = true
        this.companyResults = []
        this.companySearched = true
        this.$nextTick(() => {
          this.companyFillingFromApi = false
        })
      },
      validateInvoiceAndCompany () {
        if (!this.invoiceType) {
          bus.$emit('show_dialog', ['خطا', 'لطفا نوع فاکتور را انتخاب کنید'])
          return false
        }
        if (this.invoiceType === 'official') {
          const nationalId = this.persian_to_english((this.companyNationalId || '').trim())
          const legalTitle = (this.companyLegalTitle || '').trim()
          if (!nationalId || !legalTitle) {
            bus.$emit('show_dialog', ['خطا', 'لطفا نام شرکت و شناسه ملی شرکت را وارد کنید'])
            return false
          }
        }
        return true
      },
      saveCompanyToRequestData (passing_data) {
        passing_data.invoice_type = this.invoiceType
        if (this.invoiceType === 'official') {
          const nationalId = this.persian_to_english((this.companyNationalId || '').trim())
          const legalTitle = (this.companyLegalTitle || '').trim()
          passing_data.LegalTitle = legalTitle
          passing_data.NationalID = nationalId
          passing_data.is_company = true
        } else {
          passing_data.LegalTitle = ''
          passing_data.NationalID = ''
          passing_data.is_company = false
        }
        return passing_data
      },
      addCompanyFrmReq () {
        if (this.invoiceType !== 'official') {
          return Promise.resolve()
        }
        const send_data = {
          UserId: this.profile.UserId,
          LegalTitle: (this.companyLegalTitle || '').trim(),
          NationalID: this.persian_to_english((this.companyNationalId || '').trim()),
        }
        return this.axios.post('/AddCompanyFrmReq', send_data, {})
      },
      login () {
        // this.mobile = this.persian_to_english(this.mobile)
        var eddited_mobile = this.persian_to_english(this.mobile)
        if(!eddited_mobile.startsWith(0) && eddited_mobile.length==10){
          eddited_mobile="0"+eddited_mobile
        }
        var self = this
        if (this.level == 1) {
          const send_data = {
            Phone: eddited_mobile,
          }
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/CheckExistsMobileNo', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log('response', response)
                self.user_registered = true
                self.fullName2 = response.data.msg
                // self.level = 2;
              } else {
                self.not_register = true
                self.user_registered = false

              }
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })
        } else if (this.level == 2) {
          if (!this.validateInvoiceAndCompany()) {
            return
          }
          var eddited_mobile = this.persian_to_english(this.mobile)
          if(!eddited_mobile.startsWith(0) && eddited_mobile.length==10){
            eddited_mobile="0"+eddited_mobile
          }
           eddited_mobile = eddited_mobile.substring(1)
          self.nationalCode = this.persian_to_english(self.nationalCode);
          eddited_mobile = '+98' + eddited_mobile
          if (self.mobile != '' && self.fullName2 != '') {
            const send_data = {
              Phone: eddited_mobile,
              Password: self.password,
              NationalCode: self.nationalCode,
              OsName: 'win',
              AppNo: '3',
              OsVersion: '5',
              DeviceModel: 'android',
              UserName: self.fullName2,
              PartyId: localStorage.getItem('party_id'),

            }
            // this.axios.post('/Register' , send_data,{
            this.axios.post('/CustomerRegistration', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  console.log('response login', response)

                  var passing_data = JSON.parse(localStorage.getItem('request_data'))
                  passing_data.customer_mobile = eddited_mobile
                  passing_data.customer_name = self.fullName2
                  passing_data = self.saveCompanyToRequestData(passing_data)
                  localStorage.setItem('request_data', JSON.stringify(passing_data))
                  self.user_registered = true
                  self.addCompanyFrmReq()
                    .then(() => {
                      self.$router.push({ name: 'Categories', params: { passing_data: self.passing_data } })
                    })
                    .catch(() => {
                      self.$router.push({ name: 'Categories', params: { passing_data: self.passing_data } })
                    })
                } else {
                  bus.$emit('show_toast', [1500, response.data.msg])
                }
              }).catch(e => {
              self.errors.push(e)
            })
          }
        }
        if (this.mobile == '') {
          this.errors.push(this.$t('insertCorrectMobileNo'))
        }
        if (this.fullName2 == '') {
          this.errors.push(this.$t('insertFullName'))
        }
      },

      go_to_categories () {
        // var PassingData = {'on_site_service':OnSite}
        if (this.fullName2 != '') {
          if (!this.validateInvoiceAndCompany()) {
            return
          }
          var self = this
          var eddited_mobile = this.persian_to_english(this.mobile)
          if(!eddited_mobile.startsWith(0) && eddited_mobile.length==10){
            eddited_mobile="0"+eddited_mobile
          }
          eddited_mobile = eddited_mobile.substring(1)

          eddited_mobile = '+98' + eddited_mobile
          var passing_data = JSON.parse(localStorage.getItem('request_data'))
          passing_data.customer_mobile = eddited_mobile
          passing_data.customer_name = this.fullName2
          passing_data = this.saveCompanyToRequestData(passing_data)
          localStorage.setItem('request_data', JSON.stringify(passing_data))

          this.addCompanyFrmReq()
            .then(() => {
              self.$router.push({ name: 'Categories', params: { passing_data: self.passing_data } })
            })
            .catch(e => {
              self.errors.push(e)
              self.$router.push({ name: 'Categories', params: { passing_data: self.passing_data } })
            })
        } else {
          bus.$emit('show_dialog', [this.$t('error'), this.$t('insertCustomerMobileNo')])
        }
      }
    }
  }
</script>
